import React from "react";
import EngagementVideoPage from "../../ui/EngagementVideoPage";

const KindnessProm = () => (
  <EngagementVideoPage
    title="Kindness Prom"
    videoUrl="https://www.youtube.com/embed/ZVtBr-ibf4o"
    videoTitle="Kindness Prom"
  >
    <p>
      The &quot;Kindness Prom&quot; 2025, held during World Kindness Week, brought together Kindness Unlimited (KU) and MANN – Centre for Individuals with Special Needs – to celebrate inclusion, abilities, and shared joy through an uplifting evening of games, music, dance, and community connection. This collaborative event, supported by The Salsette Society, The Rotary Club of Mumbai Parleshwar and the DLLE team of St. Andrew&apos;s College of Arts, Science and Commerce reinforced the power of kindness to create meaningful, memorable and truly inclusive experiences.
    </p>
  </EngagementVideoPage>
);

export default KindnessProm;
